module.exports = __webpack_public_path__ + "static/volume.ebf9b7c55eecc4111c111ff4745733c6.svg";